import { combineReducers } from 'redux';

import auth from './auth';
import siteInfo from './siteInfo';
import profile from './profile';

/* App Launch */
import app from './app';

/* Question Dialog */
import questionDialog from './questionDialog';

/* location */
import location from './location';

/* Chats */
import chat from '../../scenes/Chat/services/redux';

/* Home */
import questions from '../../scenes/Home/services/redux';

/* Upload Iamge */
import uploadImage from '../../scenes/UploadImage/services/redux/uploadImage';

/* askQuestion */
import askQuestion from './askQuestion';

/* rate qestion */
import rateQuestion from './rate';

/* question indicator */
import questionIndicator from './questionIndicator';

/* alert banner */
import alertBanner from './alertBanner';

/* signupDialog banner */
import signupDialog from './signupDialog';

/* downloadDialog banner */
import downloadDialog from './downloadDialog';

/* questionListTutorial */
import questionListTutorial from './questionListTutorial';

/* internet */
import internet from './internet';

/* googleTagManager */
import googleTagManager from './googleTagManager';
import questionList from './questionList';
import openQuestion from './openQuestion';

// pubnub
import pubnubQuestionList from './pubnubQuestionList';

// bank
import bank from './bank';

// imageViewer
import imageViewer from './imageViewer';
import tutorial from './tutorial';
import questionQuota from './questionQuota';

import report from './report';

const rootReducer = combineReducers({
  auth,
  siteInfo,
  app,
  questionDialog,
  location,
  profile,
  chat,
  uploadImage,
  askQuestion,
  questions,
  rateQuestion,
  questionIndicator,
  alertBanner,
  signupDialog,
  downloadDialog,
  questionListTutorial,
  internet,
  googleTagManager,
  questionList,
  openQuestion,
  pubnubQuestionList,
  imageViewer,
  tutorial,
  questionQuota,
  report,
  bank,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/services/redux/index.js